<template>
    <div class="box overflow_hidden">
        <div class="nav bg_191919 fl">
            <div class="navHeader tc">
                <!--        <img class="img-center" src="/data/manage/images/comm/logo.png" alt="" style="width: 41px;height: 26px" />-->
                <span class="f18 txt_white ffPMP img-center">爱兜科技后台管理系统</span>
            </div>
            <hr/>
            <ul>
                <li v-for="(v,key) in options" :key="key" v-if="v.able" class="cursor_pointer" :class="option===v.router&&'active'" @click="navEvent(v.router)">
                    <div class="fl">
                        <img class="img-center" :src="v.src" alt=""/>
                        <span class="f14 txt_white ffPLP" v-text="v.text"></span>
                    </div>
                    <div class="fr">
                        <Icon type="ios-arrow-forward" color="white" size="20" class="tr"/>
                    </div>
                </li>
            </ul>
        </div>
        <div class="header bg_white">
            <div class="quickNav fl f14 bold400">
                <div class="fl" v-for="(v,key) in navData" :key="key">
                    <span v-text="v.text"></span>
                    <span v-if="key<navData.length-1">/</span>
                </div>
            </div>
            <div class="user fr cursor_pointer" @click.stop="userOptions=!userOptions">
                <Icon class="fl" type="ios-contact" size="24"/>
                <span class="f14 bold400" v-text="phone"></span>

                <div class="options bg_white" v-show="userOptions">
                    <div @click="loginoutEvent">
                        <Icon type="md-log-out" size="14"/>
                        <span class="f12 ffPMP bold500">退出登录</span>
                    </div>
                    <div @click="changePswEvent">
                        <Icon type="md-key" size="14"/>
                        <span class="f12 ffPMP bold500">修改密码</span>
                    </div>
                </div>
            </div>
            <div class="info fr cursor_pointer">
                <Icon type="ios-notifications-outline" size="24" color="black"/>
                <div class="bg_F44336 tc txt_white">5</div>
            </div>
        </div>

        <div class="content">
            <div>
                <survey v-show="option===options[0].router" v-if="options[0].loaded&&options[0].able" :ref="options[0].router" @changeNavData="changeNavData"></survey>
                <agent v-show="option===options[1].router" v-if="options[1].loaded&&options[1].able" :ref="options[1].router" @changeNavData="changeNavData"></agent>
                <project v-show="option===options[2].router" v-if="options[2].loaded&&options[2].able" :ref="options[2].router" @changeNavData="changeNavData"></project>
                <user v-show="option===options[3].router" v-if="options[3].loaded&&options[3].able" :ref="options[3].router" @changeNavData="changeNavData"></user>
                <order v-show="option===options[4].router" v-if="options[4].loaded&&options[4].able" :ref="options[4].router" @changeNavData="changeNavData"></order>
<!--                <account v-show="option===options[5].router" v-if="options[5].loaded&&options[5].able" :ref="options[5].router" @changeNavData="changeNavData"></account>-->
                <maintain v-show="option===options[5].router" v-if="options[5].loaded&&options[5].able" :ref="options[5].router" @changeNavData="changeNavData"></maintain>
                <partner v-show="option===options[6].router" v-if="options[6].loaded&&options[6].able" :ref="options[6].router" @changeNavData="changeNavData"></partner>
                <refund v-show="option===options[7].router" v-if="options[7].loaded&&options[7].able" :ref="options[7].router" @changeNavData="changeNavData"></refund>
                <invoice v-show="option===options[8].router" v-if="options[8].loaded&&options[8].able" :ref="options[8].router" @changeNavData="changeNavData"></invoice>
            </div>
        </div>
        <change-password ref="changePassword"></change-password>
    </div>
</template>

<script>
    import Survey from '../survey'
    import Agent from '../agent'
    import Project from '../project'
    import User from '../user'
    import Order from '../order'
    import Account from '../account'
    import Maintain from '../maintain'
    import Partner from '../partner'
    import Refund from '../refund'
    import Invoice from '../invoice'
    import ChangePassword from './changePassword'
    import {mapGetters} from "vuex";

    export default {
        name: "home",
        components: {
            Survey, Agent, Project, User, Order, Account, Maintain, Partner, Refund, Invoice, ChangePassword
        },
        data() {
            return {
                userOptions: false,
                options: [
                    {router: 'survey', text: '概况', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin','agent','partner']},
                    {router: 'agent', text: '代理商管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin']},
                    {router: 'project', text: '项目管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin','agent','partner']},
                    {router: 'user', text: '用户管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin']},
                    {router: 'order', text: '订单管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin','agent']},
                    // {router: 'account', text: '账户管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['agent']},
                    {router: 'maintain', text: '维护人员管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['agent']},
                    {router: 'partner', text: '合伙人管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['agent']},
                    {router: 'refund', text: '退款管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin','agent']},
                    {router: 'invoice', text: '发票管理', src: '/data/manage/images/comm/icon_users.png', loaded: 0, role: ['admin']},
                ],
                option: '',
                navData: []
            }
        },
        created() {
            this.initRole();
            this.getOption();
            document.body.addEventListener('click', this.closeLogout, false);
        },
        destroyed() {
            document.body.removeEventListener('click', this.closeLogout);
        },
        computed: {
            ...mapGetters({
                role: 'user/role',
                phone: 'user/phone',
            }),
        },
        methods: {
            getOption() {
                this.option = this.$route.params.option;
                if (!this.option) {
                    let router = this.options.find(item => item.able).router;
                    this.$router.push({
                        path: '/home/' + router
                    })
                } else {
                    this.options.forEach(item => {
                        if (item.router === this.option) {
                            item.loaded = 1;
                        }
                    });
                    this.$nextTick(() => {
                        if (this.$refs[this.option] && this.$refs[this.option].init) {
                            this.$refs[this.option].init();
                        }
                    })
                }
            },
            initRole() {
                this.options.forEach(item => {
                    item.able = item.role.includes(this.role);
                });
            },
            navEvent(option) {
                this.$router.push({
                    path: '/home/' + option
                });
            },
            closeLogout() {
                this.userOptions = false;
            },
            loginoutEvent() {
                this.userOptions = false;
                let phone = this.$store.getters['user/phone'];
                this.$api.post('/manage/loginout',{
                    phone: phone
                }).then((data) => {
                    if(!data){
                        this.$store.commit('user/setLogin',{status: false});
                        this.$router.push({path: '/login'});
                    }else{
                        this.$alert.warning({content: data});
                    }
                }).catch((error) => {
                    this.$alert.error({content: '退出登录出错，请重试'});
                })
            },
            changePswEvent() {
                this.$refs.changePassword.init();
            },
            changeNavData(data) {
                this.navData = data;
            }
        },
        watch: {
            '$route'() {
                this.getOption();
            },
            'role'() {
                this.initRole();
                this.$router.push({
                    path: '/home/' + this.options.find(item => item.able).router
                })
            }
        }
    }
</script>

<style scoped>
    .box {
        height: 100%;
    }

    .nav {
        width: 260px;
        min-height: 100%;
        padding: 0 15px;
    }

    .navHeader {
        height: 26px;
        line-height: 26px;
        margin: 18px 0;
    }

    .navHeader > img {
        margin-right: 8px;
    }

    .nav > hr {
        border: none;
        width: 100%;
        height: 2px;
        background-color: rgba(181, 181, 181, .3);
        margin-bottom: 19px;
    }

    .nav > ul > li {
        width: 100%;
        height: 46px;
        line-height: 46px;
        margin-bottom: 10px;
        border-radius: 3px;
    }

    .nav > ul > li > div > img {
        margin: 0 12px;
    }

    .nav > ul > li:hover {
        background: rgba(255, 255, 255, 0.2);
    }

    .nav > ul > .active, .nav > ul > .active:hover {
        background-color: #E91E63;
        box-shadow: 0 7px 10px -5px rgba(233, 30, 99, 0.4), 0 4px 4px 0 rgba(0, 0, 0, 0.14);
    }

    .nav > ul > .active > div:nth-of-type(2) {
        display: none;
    }

    .header {
        height: 64px;
        margin-left: 260px;
        box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
    }

    .quickNav {
        margin-left: 27px;
        height: 100%;
        line-height: 64px;
        color: rgba(0, 0, 0, 0.45);
    }

    .quickNav > div > span:nth-of-type(2) {
        margin: 0 8px 0 6px;
    }

    .info {
        width: 24px;
        height: 24px;
        margin: 20px;
        position: relative;
    }

    .info > div {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 12px;
        transform: scale(.7);
        -webkit-transform: scale(.7);
        -moz-transform: scale(.7);
        -ms-transform: scale(.7);
        -o-transform: scale(.7);
        -webkit-transform-origin: 20px 0;
        -moz-transform-origin: 20px 0;
        -ms-transform-origin: 20px 0;
        -o-transform-origin: 20px 0;
    }

    .user {
        height: 24px;
        line-height: 24px;
        margin: 20px 24px 20px 0;
        color: rgba(0, 0, 0, 0.65);
        position: relative;
    }

    .user > i {
        margin-right: 5px;
    }

    .user > .options {
        position: absolute;
        top: 54px;
        right: -12px;
        width: 120px;
        line-height: 30px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.24);
        border-radius: 4px;
        padding: 8px 0;
        z-index: 10;
    }

    .user > .options > div {
        padding: 0 15px;
        color: #818181;
    }

    .user > .options > div > span {
        margin-left: 5px;
    }

    .user > .options > div:hover {
        background: #E91E63;
        color: white;
    }

    .content {
        padding: 20px 3px 84px 20px;
        margin-left: 260px;
        height: 100%;
    }

    .content > div {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        overflow-x: auto;
    }

    .content > div > div{
        min-width: 1140px;
    }
</style>
